<template>
   <div id="rent-a-car-search-form-container" class="col-12">
      <transition name="fade" mode="out-in">
         <SearchInformationPopup ref="rentacarInformationPopup" :label="'rentacarSearchInformation'" variant="rentacar" />
      </transition>

      <div class="row">
         <div class="col-12 col-md-4">
            <RentACarLocations @location="handlerLocationSetter" :isValid="formValidationObj.location" />
         </div>

         <div class="col-12 col-md">
            <RentACarDateTimePicker
               :identifier="1"
               :label="$t('rentacar_pickupDate')"
               :date="dates.pickup.date"
               :time="dates.pickup.time"
               :isValid="formValidationObj.pickupDate"
               @update-date="handlerPickUpDate"
               @update-time="handlerPickUpTime" />
         </div>
         <div class="col-12 col-md">
            <RentACarDateTimePicker
               :identifier="2"
               :label="$t('rentacar_dropoffDate')"
               :date="dates.dropoff.date"
               :time="dates.dropoff.time"
               :isValid="formValidationObj.dropoffDate"
               :min-date="dates.pickup.date"
               :sibling="dates.pickup.time"
               @update-date="handlerDropOffDate"
               @update-time="handlerDropOffTime" />
         </div>
         <div class="col-12 col-lg-2 mt-3" id="button-wrapper">
            <UIButton className="rentacar" :text="$t('common_search')" @click.native="handlerSendRequest" :isSpinnerActive="spinnerStatus" />
         </div>
         <div class="rent-a-car-search-info-box">
            <p><i></i>{{ $t("rentacarSearchForm_lblCreditCardDepositInfo") }}</p>
         </div>
      </div>
   </div>
</template>

<script>
import SearchInformationPopup from "@/components/unitary/SearchInformationPopup.vue";
import RentACarLocations from "@/components/structural/rentacar/search/search-forms/RentACarLocations.vue";
import RentACarDateTimePicker from "@/components/structural/rentacar/search/search-forms/RentACarDateTimePicker.vue";
import UIButton from "@/components/unitary/Button.vue";
import { rentacarService } from "@/service/index.js";
import { generateUuid } from "@/utils.js";
import moment from "moment";
export default {
   name: "RentACarSearchForm",
   components: {
      RentACarLocations,
      RentACarDateTimePicker,
      SearchInformationPopup,
      UIButton,
   },
   data() {
      return {
         dates: {
            pickup: { date: moment().add(1, "d").format(this.$constants.dateFormat), time: null },
            dropoff: { date: moment().add(7, "d").format(this.$constants.dateFormat), time: null },
         },
         //delete below
         isFormValid: true,
         formValidationObj: {
            location: true,
            pickupDate: true,
            dropoffDate: true,
         },
         pickUpLocationName: null,
         dropOffLocationName: null,
         query: {
            uuid: null,
            pickUpLocationId: null,
            dropOffLocationId: null,
            pickUpDateTime: "",
            dropOffDateTime: "",
            agencyCommissionExtra: Number,
            online: false,
         },
         spinnerStatus: false,
      };
   },
   computed: {},
   methods: {
      SearchBtnFMT() {
         // const pickup = moment(this.dates.pickup.date, "YYYY-MM-DD");
         // const dropoff = moment(this.dates.dropoff.date, "YYYY-MM-DD");
         // const difference = dropoff.diff(pickup, "days");

         // if (difference == 0) {
         //    return this.$t("rentacar_btnSearchDaily");
         // } else {
         //    return this.$t("rentacar_btnSearch").replace("#VALUE#", difference + 1);
         // }
         return this.$t("rentacar_btnSearchDaily");
      },
      handlerSendRequest() {
         if (this.query.dropOffLocationId == null) {
            this.query.dropOffLocationId = this.query.pickUpLocationId;
         }

         const validation = [
            this.query.pickUpLocationId != null,
            this.query.dropOffLocationId != null,
            this.query.dropOffDateTime.length == 16,
            this.query.pickUpDateTime.length == 16,
         ];

         this.query.pickUpLocationId != null ? (this.formValidationObj.location = true) : (this.formValidationObj.location = false);
         this.query.dropOffLocationId != null ? (this.formValidationObj.location = true) : (this.formValidationObj.location = false);
         this.query.pickUpDateTime.length == 16 ? (this.formValidationObj.pickupDate = true) : (this.formValidationObj.pickupDate = false);
         this.query.dropOffDateTime.length == 16 ? (this.formValidationObj.dropoffDate = true) : (this.formValidationObj.dropoffDate = false);

         this.isFormValid = validation.every((item) => {
            return item;
         });

         if (this.isFormValid) {
            this.query.uuid = generateUuid();

            this.$store.commit("rentacar/setIsSearching", true);

            this.$store.commit("rentacar/setSearchQuery", {
               pickupFrom: this.pickUpLocationName,
               dropOff: this.dropOffLocationName ? this.dropOffLocationName : this.pickUpLocationName,
               pickupDateTime: this.query.pickUpDateTime,
               dropOffDateTime: this.query.dropOffDateTime,
            });

            this.query.agencyCommissionExtra = this.$store.state.rentacar.agencyCommissionExtra;
            this.spinnerStatus = true;
            rentacarService.rentacarSearch(this.query).then((response) => {
               this.$parent.$emit("search-response", response);
               this.$store.commit("rentacar/setIsSearching", false);
               this.spinnerStatus = false;
            });
         }
      },
      handlerLocationSetter(obj) {
         if (obj.identifier == 1) {
            this.query.pickUpLocationId = obj.location.locationId;
            this.pickUpLocationName = obj.location.locationName;
            // this.isValid.pickUp = true;
         } else if (obj.identifier == 2) {
            this.query.dropOffLocationId = obj.location.locationId;
            this.dropOffLocationName = obj.location.locationName;
            // this.isValid.dropOff = true;
         }
      },
      handlerPickUpDate(date) {
         this.dates.pickup.date = date;
      },
      handlerPickUpTime(time) {
         this.dates.pickup.time = time;
      },
      handlerDropOffDate(date) {
         this.dates.dropoff.date = date;
      },
      handlerDropOffTime(time) {
         this.dates.dropoff.time = time;
      },
   },
   watch: {
      "query.pickUpLocationId": {
         handler: function (id) {
            if (id == null) {
               this.isFormValid = false;
            } else {
               this.isFormValid = true;
            }
         },
      },
      dates: {
         handler: function (dates) {
            const pickupDate = dates.pickup.date;
            const dropoffDate = dates.dropoff.date;

            if (pickupDate > dropoffDate) {
               this.dates.dropoff.date = moment(pickupDate, "YYYY-MM-DD").add(1, "d").format("YYYY-MM-DD");
            }

            const pickup = `${this.dates.pickup.date}T${this.dates.pickup.time}`;
            const dropoff = `${this.dates.dropoff.date}T${this.dates.dropoff.time}`;

            this.query.pickUpDateTime = pickup;
            this.query.dropOffDateTime = dropoff;
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
#rent-a-car-search-form-container {
   background-color: #fff;
   //    border: 1px solid #eee;
   // padding: 2rem;
   border-radius: 1rem;

   .row {
      > div {
         //  border: 1px solid #ccc;
         padding: 0 0.65rem;

         &.rent-a-car-search-info-box {
            margin-top: 1.5rem;
            p {
               display: flex;
               align-items: center;
               font-size: var(--small);
               font-weight: 500;
               color: #363636;
               margin-left: 0.5rem;
               i {
                  background-image: url("data:image/svg+xml;base64,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");
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size: contain;
                  width: 20px;
                  height: 20px;
                  display: block;

                  margin-right: 0.5rem;
               }
            }
         }
      }
   }

   #button-wrapper {
      display: flex;
      align-items: flex-end;
      ::v-deep {
         button {
            width: 100%;
         }
      }
   }
}
</style>
